// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19-sq","option":"styles_option__38EJS","selected":"styles_selected__cHnnX"};